module.exports = __webpack_public_path__ + "img/main_img_3.10c48200.jpg";